<template>
  <Transition
    enter-active-class="overlay-enter-active"
    leave-active-class="overlay-leave-active"
    enter-from-class="overlay-enter-from"
    leave-to-class="overlay-leave-to"
  >
    <div v-if="isLoading" class="global-overlay" aria-live="polite" aria-busy="true">
      <div class="spinner" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useGlobalLoading } from '@/composables/useGlobalLoading'

const { isLoading } = useGlobalLoading()
</script>

<style scoped>
.global-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.2s ease;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.25);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
